export default __webpack_public_path__ + "static/media/2.a7bfe907.jpg";